import { motion } from 'framer-motion'
import { LinkButton } from '@/components/ui/LinkButton'

export function ScentQuizTeaser() {
  return (
    <section className="bg-card py-20">
      <div className="mx-auto max-w-content px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-col items-center justify-between gap-8 border border-line bg-paper p-8 text-center md:flex-row md:p-12 md:text-left"
        >
          <div className="max-w-text-block">
            <p className="mb-3 font-condensed text-xs uppercase tracking-[0.2em] text-wd-orange">Not sure where to start?</p>
            <h2 className="font-display text-3xl normal-case text-carbon md:text-4xl">find your scent</h2>
            <p className="mt-3 text-carbon/60">Answer 6 quick questions and we will match you to three fragrances worth trying.</p>
          </div>
          <LinkButton to="/scent-quiz" variant="secondary">Take the quiz</LinkButton>
        </motion.div>
      </div>
    </section>
  )
}
